import type { UploadedFile } from 'models';
import { generateAttachmentsInputFileListItem } from './generate-attachments-input-file-list-item';

export const generateAttachmentsInputInitialValue = (files?: UploadedFile[]) =>
  files ? { fileList: files.map((file) => generateAttachmentsInputFileListItem(file)) } : { fileList: [] };
